/*
 * 1DS JS SDK Properties plugin, 4.0.2
 * Copyright (c) Microsoft and contributors. All rights reserved.
 * (Microsoft Internal Only)
 */
/**
* Cloud.ts
* @author Hector Hernandez (hectorh)
* @copyright Microsoft 2020
*/
var Cloud = /** @class */ (function () {
    function Cloud() {
    }
    return Cloud;
}());
export { Cloud };
//# sourceMappingURL=Cloud.js.map